import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const PageNotFound = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page Not Found | My Builder ID</title>
        <meta name="robots" content="noindex" />
        <meta
          name="description"
          content="Sorry, the page you are looking for could not be found."
        />
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "60vh",
          textAlign: "center",
          padding: "40px 20px",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div
          style={{
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          <h1
            style={{
              fontSize: "8rem",
              fontWeight: "bold",
              color: "#6c757d",
              margin: "0",
              lineHeight: "1",
            }}
          >
            404
          </h1>

          <h2
            style={{
              fontSize: "2rem",
              color: "#495057",
              marginBottom: "1rem",
            }}
          >
            Page Not Found
          </h2>

          <p
            style={{
              fontSize: "1.2rem",
              color: "#6c757d",
              marginBottom: "2rem",
              lineHeight: "1.6",
            }}
          >
            Sorry, the page you are looking for doesn't exist or has been moved.
          </p>

          <div
            style={{
              display: "flex",
              gap: "1rem",
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Link
              to="/"
              style={{
                display: "inline-block",
                padding: "12px 24px",
                backgroundColor: "#007bff",
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
                fontSize: "1rem",
                transition: "background-color 0.3s",
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.target.style.backgroundColor = "#007bff")}
            >
              Go to Homepage
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PageNotFound;
